import activityLogRoutes from 'modules/activityLog/common/routing/routes'

const routes = {
  root: activityLogRoutes.root,
}

export default routes
